import { useCallback, useState } from 'react'

const useClipboard = () => {
  const [lastCopied, setLastCopied] = useState()
  const handleCopy = useCallback(
    (text) => {
      navigator.clipboard.writeText(text)
      setLastCopied(text)
    },
    [setLastCopied],
  )

  return [handleCopy, lastCopied]
}

export default useClipboard
